__turbopack_context__.v({
  "brand": "styles-module-scss-module__gyGOkW__brand",
  "container": "styles-module-scss-module__gyGOkW__container",
  "coverItem": "styles-module-scss-module__gyGOkW__coverItem",
  "hasProductLink": "styles-module-scss-module__gyGOkW__hasProductLink",
  "product": "styles-module-scss-module__gyGOkW__product",
  "productDetails": "styles-module-scss-module__gyGOkW__productDetails",
  "productImage": "styles-module-scss-module__gyGOkW__productImage",
  "productsContainer": "styles-module-scss-module__gyGOkW__productsContainer",
  "productsGrid": "styles-module-scss-module__gyGOkW__productsGrid",
});
